import React, { useState, useEffect } from "react";
import { IonButton, IonInput, IonLabel, IonItem, IonList } from "@ionic/react";

const GreaterLessThanEasy: React.FC = () => {
    const [number1, setNumber1] = useState<number>(0);
    const [number2, setNumber2] = useState<number>(0);
    const [userInput, setUserInput] = useState<string>("");
    const [feedback, setFeedback] = useState<string | null>(null);
    const [showImage, setShowImage] = useState(false);
    const [error, setError] = useState(false);

    // Function to generate new question
    const generateQuestion = () => {
        setNumber1(Math.floor(Math.random() * 90) + 10); // Random two-digit number
        setNumber2(Math.floor(Math.random() * 90) + 10);
        setUserInput("");
        setFeedback(null);
    };

    // Check user answer
    const checkAnswer = (operator: string) => {
        let correctOperator;
        if (number1 > number2) {
            correctOperator = ">";
        } else if (number1 < number2) {
            correctOperator = "<";
        } else {
            correctOperator = "=";
        }

        if (operator === correctOperator) {
            setShowImage(true);
            setFeedback("Correct! Generating a new question...");
            setTimeout(() => {
                generateQuestion();
                setShowImage(false);
                setError(false);
            }, 5000); // Generate a new question after 2 seconds
        } else {
            setError(true);
        }
    };

    // Generate the first question on component mount
    useEffect(() => {
        generateQuestion();
        document.title = "Mamas Guidance - Class One - Mathematics - Greater Than / Less Than / Equal - Easy"; // Set page title
    }, []);

    return (
        <>
            {
                showImage === false ?
                    <>
                        <div className='contentPart '>
                            <div className="worksheet-container text-center" style={{ marginTop: '70px ' }}>
                                <div className="grid-container">
                                    <div className="grid-box d-none d-md-block"></div>
                                    <div className="grid-box grid-container-second">
                                        <div className="grid-box">    {number1} </div>
                                        <div className="grid-box"><input
                                            type="text"
                                            value={userInput}
                                            placeholder="?"
                                            readOnly
                                            className={`form-control ${error == true ? 'error' : ''} `}
                                        /></div>
                                        <div className="grid-box">    {number2}</div>
                                    </div>
                                    <div className="grid-box d-none d-md-block"></div>
                                </div>

                                <div className=" mt-4 text-center" style={{ display: "flex", justifyContent: "center", gap: "10px", flexWrap: "wrap", marginLeft: 0 }}>
                                    <div className="background-blue" style={{ margin: "5px", padding: "10px", minWidth: "60px" }} onClick={() => checkAnswer(">")}>&gt;</div>
                                    <div className="background-blue" style={{ margin: "5px", padding: "10px", minWidth: "60px" }} onClick={() => checkAnswer("<")}>&lt;</div>
                                    <div className="background-blue" style={{ margin: "5px", padding: "10px", minWidth: "60px" }} onClick={() => checkAnswer("=")}>=</div>
                                </div>
                            </div>
                        </div>
                    </>
                    :
                    <>
                        <div className="contentPart showMiddle">
                            <img style={{ height: '150px' }} className='img-fluid' src={process.env.REACT_APP_WELDONE_LINK} />
                        </div>
                    </>
            }
        </>
    );
};

export default GreaterLessThanEasy;
